import { GetTatumApiKey } from "./getTatumApiKey";
import { PasteApiKey } from "./pasteApiKey";
import { WhyApiKey } from "./whyApiKey";
import { PriceOverview } from "./priceOverview";
import { MoreTatum } from "./moreTatum";
export var GetApiKey = function GetApiKey() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WhyApiKey, null), /*#__PURE__*/React.createElement(GetTatumApiKey, null), /*#__PURE__*/React.createElement(PasteApiKey, null), /*#__PURE__*/React.createElement(PriceOverview, null), /*#__PURE__*/React.createElement(MoreTatum, null));
};